import {Component, computed, input} from '@angular/core';

export enum Status {
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
  READY_FOR_ONBOARDING = "READY_FOR_ONBOARDING"
}

@Component({
  selector: 'app-bluetooth-svg',
  imports: [],
  templateUrl: './bluetooth-svg.component.html',
  styleUrl: './bluetooth-svg.component.css'
})
export class BluetoothSvgComponent {

  width = input('50');
  height = input('50');
  status = input(Status.OFFLINE);
  edgeColor = input('#0076f7');
  backgroundColor = computed(() => {
    switch (this.status()) {
      case Status.ONLINE: return '#0076f7';
      case Status.OFFLINE: return '#FF401F';
      case Status.READY_FOR_ONBOARDING: return '#DFDFDF';
    }
  });
}
